/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A constructor's championship total is the sum of the points both of its drivers score across the season. That is why a team with two consistent points-scorers can outrank a team that relies on one star driver, and why constructor form is a useful signal when picking your two fantasy constructors.`)
};

const es_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El total de un constructor en el campeonato es la suma de los puntos que anotan sus dos pilotos durante la temporada. Por eso un equipo con dos pilotos que puntúan de forma consistente puede superar a un equipo que depende de una sola estrella, y por eso la forma del constructor es una señal útil al elegir tus dos constructores de fantasy.`)
};

const de_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Meisterschaftsstand eines Konstrukteurs ist die Summe der Punkte, die beide seiner Fahrer über die Saison erzielen. Deshalb kann ein Team mit zwei konstanten Punktesammlern ein Team überflügeln, das sich auf einen Startfahrer verlässt — und deshalb ist die Konstrukteursform ein nützliches Signal bei der Wahl deiner beiden Fantasy-Konstrukteure.`)
};

const nl_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het kampioenschapstotaal van een constructeur is de som van de punten die beide coureurs gedurende het seizoen scoren. Daarom kan een team met twee consistente puntenscoorders een team overtreffen dat afhankelijk is van één sterrencoureur, en daarom is de constructeursvorm een nuttig signaal bij het kiezen van je twee fantasy-constructeurs.`)
};

const fr_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le total au championnat d'un constructeur est la somme des points marqués par ses deux pilotes sur la saison. C'est pourquoi une équipe avec deux pilotes réguliers peut devancer une équipe qui dépend d'un seul pilote star, et pourquoi la forme du constructeur est un signal utile pour choisir vos deux constructeurs fantasy.`)
};

const it_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il totale di un costruttore in campionato è la somma dei punti ottenuti da entrambi i suoi piloti durante la stagione. Ecco perché un team con due piloti costanti nei punti può superare un team che dipende da un solo pilota di punta, e perché la forma del costruttore è un segnale utile nella scelta dei tuoi due costruttori fantasy.`)
};

const pt_br2_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O total de um construtor no campeonato é a soma dos pontos que seus dois pilotos marcam ao longo da temporada. É por isso que um time com dois pilotos consistentes na pontuação pode superar um time que depende de um único piloto estrela, e por isso a forma do construtor é um sinal útil ao escolher seus dois construtores no fantasy.`)
};

const pt_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O total de um construtor no campeonato é a soma dos pontos que ambos os seus pilotos marcam ao longo da época. É por isso que uma equipa com dois pilotos consistentes a pontuar pode superar uma equipa que depende de um único piloto estrela, e por isso a forma do construtor é um sinal útil ao escolher os seus dois construtores fantasy.`)
};

const ja_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンストラクターの選手権合計は、シーズンを通して両ドライバーが獲得したポイントの合計です。そのため、安定してポイントを獲得する2人のドライバーを擁するチームは、1人のスタードライバーに依存するチームを上回ることがあります。だからこそコンストラクターのフォームは、ファンタジーのコンストラクターを2つ選ぶ際に役立つシグナルとなります。`)
};

const zh_f1_st_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一支车队的锦标赛总分是其两位车手在整个赛季中获得积分的总和。这就是为什么拥有两名稳定得分车手的车队能够超越依赖单一明星车手的车队,也是为什么车队状态在挑选你的两支梦幻车队时是一个有用的信号。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_st_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_st_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_st_faq2_a", locale)
	if (locale === "en") return en_f1_st_faq2_a(inputs)
	if (locale === "es") return es_f1_st_faq2_a(inputs)
	if (locale === "de") return de_f1_st_faq2_a(inputs)
	if (locale === "nl") return nl_f1_st_faq2_a(inputs)
	if (locale === "fr") return fr_f1_st_faq2_a(inputs)
	if (locale === "it") return it_f1_st_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_st_faq2_a(inputs)
	if (locale === "pt") return pt_f1_st_faq2_a(inputs)
	if (locale === "ja") return ja_f1_st_faq2_a(inputs)
	return zh_f1_st_faq2_a(inputs)
};